module.exports = __webpack_public_path__ + "public/images/bear.16a10cae850d3d05feda6c3f46ee130b.png";